var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuNoShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.56681 15.8333C2.06972 15.8333 1.66675 15.4303 1.66675 14.9332C1.66675 14.4361 2.06972 14.0332 2.56681 14.0332H17.4334C17.9304 14.0332 18.3334 14.4361 18.3334 14.9332C18.3334 15.4303 17.9304 15.8333 17.4334 15.8333H2.56681ZM2.57821 10.9114C2.07482 10.9114 1.66675 10.5033 1.66675 9.99996C1.66675 9.49657 2.07482 9.0885 2.57821 9.0885H17.422C17.9253 9.0885 18.3334 9.49657 18.3334 9.99996C18.3334 10.5033 17.9253 10.9114 17.422 10.9114H2.57821ZM2.56681 5.96676C2.06972 5.96676 1.66675 5.56378 1.66675 5.06669C1.66675 4.5696 2.06972 4.16663 2.56681 4.16663H17.4334C17.9304 4.16663 18.3334 4.5696 18.3334 5.06669C18.3334 5.56378 17.9304 5.96676 17.4334 5.96676H2.56681Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNoShadow);
export default __webpack_public_path__ + "static/media/icon-menu-no-shadow.01eef6a1835d441897eb87f3ee6c8373.svg";
export { ForwardRef as ReactComponent };